import { render, staticRenderFns } from "./TabSection.vue?vue&type=template&id=3409a873&scoped=true&"
import script from "./TabSection.vue?vue&type=script&lang=js&"
export * from "./TabSection.vue?vue&type=script&lang=js&"
import style0 from "./TabSection.vue?vue&type=style&index=0&id=3409a873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3409a873",
  null
  
)

export default component.exports